import React, { useState } from 'react';
import Widget from '../Widget/Widget';
import { format } from '../../utils';
import { useGlobalValue } from '../../state/GlobalProvider';
import styles from './AuditSummaryWidget.module.sass';

const AuditSummaryWidget = props => {
  const {
    title,
    icon,
    link,
    summary,
    expanded = true,
    children,
    modifiers
  } = props;
  const {
    i18n
  } = useGlobalValue();
  const [collapsed, setCollapsed] = useState(!(expanded || link));
  const widgetSummary = [];
  const auditSummary = summary || [];
  auditSummary.sort(({
    severity: a
  }, {
    severity: b
  }) => b.localeCompare(a));
  auditSummary.forEach(({
    severity,
    count
  }) => {
    widgetSummary.push({
      name: severity,
      value: format(count, undefined, null)
    });
  });

  if (!auditSummary.length && summary !== undefined) {
    widgetSummary.push({
      name: i18n`Status`,
      value: i18n`OK`
    });
  }

  const severityColor = auditSummary.length ? 'findings' : summary !== undefined ? 'ok' : undefined;
  return /*#__PURE__*/React.createElement(Widget, {
    modifiers: modifiers,
    className: collapsed || !children ? styles[severityColor] || '' : '',
    title: title,
    icon: icon,
    link: link,
    summary: widgetSummary,
    expanded: expanded,
    onChange: e => {
      setCollapsed(e.target.value);
    }
  }, summary && summary.length ? children : null);
};

export default AuditSummaryWidget;